import React, { useState, useEffect } from 'react';

import ClearableDropdown from 'common-components/ClearableDropdown';

import './reviseUrlCategory.style.css';


const ReviseUrlCategory = ({
  rowData,
  urlCatList,
  allCatList,
  revisedCat,
  setRevisedCat
}) => {
  const [predictedCat, setPredictedCat] = useState(null);

  useEffect(() => {
    urlCatList && setRevisedCat(rowData.revised_category ?
      rowData.revised_category : (urlCatList.length == 0 ? null : urlCatList[0]));
  }, [urlCatList]);

  const onRevisedCatChange = (event, result) => {
    const { value } = result || event.target;
    setRevisedCat(value);
  };

  const onPredictedCatChange = (event, result) => {
    const { value } = result || event.target;
    setPredictedCat(value);
  };

  return (
    <div className='review-category-container'>
      <div className='cat-header'>
        Predicted Category
      </div>
      <div className='cat-header'>
        Revised Category
      </div>
      <div className='cat-dropdown-container'>
        {urlCatList && (urlCatList.length <= 1 ? (
          <div className='predicted-cat'>
            {urlCatList.length == 0 ? 'None' : urlCatList[0]}
          </div>
        ) : (
            <ClearableDropdown
              clearable={false}
              placeHolder="Select category.."
              changeHandler={onPredictedCatChange}
              inputOptions={urlCatList.map(
                (member, index) => { return { key: index, text: member, value: member } })}
              selectedValue={predictedCat}
            />
          ))}
      </div>
      <div className='cat-dropdown-container'>
        <ClearableDropdown
          clearable={true}
          placeHolder="Select category.."
          changeHandler={onRevisedCatChange}
          inputOptions={allCatList}
          selectedValue={revisedCat}
        />
      </div>
    </div>
  )
};

export default ReviseUrlCategory;